/* istanbul ignore file */
import { styled } from "@mui/system";
import { Box, useTheme } from "@mui/material";

export const AppMainBox = styled(Box)(() => ({
  [useTheme().breakpoints.down("md")]: {
    paddingTop: "120px",
    margin: "1rem",
  },
  [useTheme().breakpoints.up("md")]: {
    paddingTop: "140px",
    margin: "1rem 5rem",

  },
}));
